import React from 'react';
import { TaskCard } from '@medely/ui-kit';
import { TaskCardLayout } from './TaskCard';
import { useProNavigate } from '@mp/contexts';
import type { RateChangeTodo } from '@mp/graphql/generated/graphql';

export function sortApprovedRateChangesByDecidedAt(items: RateChangeTodo[]): RateChangeTodo[] {
  return [...items].sort((a, b) => {
    const tb = b.request_decided_at ? new Date(b.request_decided_at).getTime() : 0;
    const ta = a.request_decided_at ? new Date(a.request_decided_at).getTime() : 0;
    return tb - ta;
  });
}

type ApprovedRateChangeCardProps = {
  item: RateChangeTodo;
};

export const ApprovedRateChangeCard = ({ item }: ApprovedRateChangeCardProps) => {
  const { navigate } = useProNavigate();

  return (
    <TaskCardLayout>
      <TaskCard
        iconProps={{
          name: 'solid-dollar-sign',
          color: 'success',
        }}
        title="Rate request approved"
        body="The facility accepted your request for higher rate. Book now."
        onClick={() => navigate('JobDetails', { id: item.job_id })}
      />
    </TaskCardLayout>
  );
};
